import { Box } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import { CoresAnimal } from "core/features/animal/animal.data";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

export interface SelectCorAnimalProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}

function SelectCorAnimal({
  value,
  onChange,
  isInvalid,
  errorMessage,
  ...rest
}: SelectCorAnimalProps) {
  const [search, setSearch] = useState<string | undefined>();

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      placeholder="Selecione a cor"
      style={{ width: "100%", flexGrow: 1, flex: 1 }}
      value={value || undefined}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={CoresAnimal}
      notFoundContent={<Box>Nenhuma cor encontrada</Box>}
    />
  );
}

export default SelectCorAnimal;
